<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: "app"
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
html,
body {
  width: 100%;
  height: 100%;
  overflow: hidden;
  font-size: 16px;
}
@media screen and (min-width: 1366px) and (max-width: 1600px) {
  html,
  body {
    font-size: 14px;
  }
}
@media screen and (min-width: 1080px) and (max-width: 1366px) {
  html,
  body {
    font-size: 12px;
  }
  .divRightTools {
    right: 4px !important;
  }
}

@media screen and (max-width: 1080px) {
  html,
  body {
    font-size: 12px;
  }
}

#app {
  color: #303030;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.el-icon-time:before {
  content: url("./assets/images/time.png");
}
</style>



// WEBPACK FOOTER //
// src/App.vue